<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PageNotFound',
  data: () => ({
    show404: false
  }),
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  created() {

    setTimeout(() => {
      this.show404 = true;
    }, 200);
  }
};
</script>

<template>
  <v-container class="d-flex align-center justify-center" style="height:81vh">
    <v-card class="error-card text-center">
      <v-card-text>
        <transition name="fade">
          <h1 v-show="show404" class="error-code">404</h1>
        </transition>
        <div class="error-text mt-14">
          <h2>{{ $t('page.pageNotFound.view.subtext') }}</h2>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" class="white--text" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('button.back') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<style scoped>
.error-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
.error-code {
  font-size: 6rem;
  font-weight: bold;
  color: #002c38;
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.3);
}
.error-text {
  text-align: center;
  font-size: 1.5rem;
  line-height: 1.3;
  margin-top: 10px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
